import React, { useEffect, useMemo, useState } from 'react'
import { supabase } from '../lib/supabase'
import { clearTariffeCache } from '../lib/dataloader'

const ZONE_SOGESSUR = [1, 2, 3, 4]
const PROVINCE_ESCLUSE = new Set(['NA', 'CE', 'RM'])

export default function AdminSogessurZone() {
  const [province, setProvince] = useState([])
  const [zone, setZone] = useState({})
  const [edits, setEdits] = useState({})
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState('')
  const [saving, setSaving] = useState(false)
  const [showEsclude, setShowEsclude] = useState(false)

  useEffect(() => { load() }, [])
  async function load() {
    setLoading(true)
    const [p, z] = await Promise.all([
      supabase.from('province').select('*').order('nome'),
      supabase.from('sogessur_zone_province').select('*'),
    ])
    setProvince(p.data || [])
    const map = {}
    for (const r of (z.data || [])) map[r.sigla] = r.zona
    setZone(map)
    setLoading(false)
  }

  async function saveAll() {
    setSaving(true)
    const toUpsert = []
    const toDelete = []
    for (const [sigla, zona] of Object.entries(edits)) {
      if (zona === '' || zona == null) toDelete.push(sigla)
      else toUpsert.push({ sigla, zona: parseInt(zona) })
    }
    if (toUpsert.length) await supabase.from('sogessur_zone_province').upsert(toUpsert)
    if (toDelete.length) await supabase.from('sogessur_zone_province').delete().in('sigla', toDelete)
    clearTariffeCache()
    setEdits({})
    await load()
    setSaving(false)
  }

  const filtered = useMemo(() => {
    const f = filter.toLowerCase().trim()
    let lista = province
    if (!showEsclude) lista = lista.filter(p => !PROVINCE_ESCLUSE.has(p.sigla))
    if (!f) return lista
    return lista.filter(p =>
      p.sigla.toLowerCase().includes(f) ||
      p.nome.toLowerCase().includes(f) ||
      (p.regione || '').toLowerCase().includes(f))
  }, [province, filter, showEsclude])

  if (loading) return <div className="loading">Caricamento...</div>

  return (
    <div>
      <div className="page-header flex-between">
        <div>
          <h1>Zone territoriali Sogessur</h1>
          <p>Mapping provincia → zona Sogessur (1..4). Le province <strong>CE, NA, RM</strong> sono escluse dalla copertura. Zone 3-4: tariffe solo con SAT.</p>
        </div>
        {Object.keys(edits).length > 0 && (
          <button className="btn btn-primary" onClick={saveAll} disabled={saving}>
            {saving ? 'Salvataggio...' : `Salva ${Object.keys(edits).length} modifiche`}
          </button>
        )}
      </div>

      <div className="card">
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', marginBottom: '1rem', flexWrap: 'wrap' }}>
          <input placeholder="Cerca provincia, sigla o regione..." value={filter}
                 onChange={e => setFilter(e.target.value)} style={{ flex: 1, minWidth: 260 }} />
          <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <input type="checkbox" checked={showEsclude} onChange={e => setShowEsclude(e.target.checked)} />
            <span className="text-small">Mostra anche province escluse (CE, NA, RM)</span>
          </label>
        </div>

        <div className="table-wrap">
          <table>
            <thead><tr><th>Sigla</th><th>Provincia</th><th>Regione</th><th>Zona Sogessur</th></tr></thead>
            <tbody>
              {filtered.map(p => {
                const valoreEdit = edits[p.sigla]
                const z = valoreEdit !== undefined ? valoreEdit : (zone[p.sigla] ?? '')
                const dirty = valoreEdit !== undefined
                const esclusa = PROVINCE_ESCLUSE.has(p.sigla)
                return (
                  <tr key={p.sigla} style={esclusa ? { opacity: 0.6 } : null}>
                    <td><strong>{p.sigla}</strong>{esclusa && <span className="text-small text-muted"> (esclusa)</span>}</td>
                    <td>{p.nome}</td>
                    <td className="text-muted">{p.regione}</td>
                    <td>
                      <select value={z} onChange={e => setEdits(s => ({ ...s, [p.sigla]: e.target.value }))}
                              style={{ width: 130, background: dirty ? '#FFF7E5' : 'transparent' }}>
                        <option value="">— nessuna —</option>
                        {ZONE_SOGESSUR.map(zn => <option key={zn} value={zn}>Zona {zn}</option>)}
                      </select>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
